import type { InjectionKey, Ref } from "vue";
import { computed, inject, provide } from "vue";

/** How a row's actions open: as a dropdown menu next to the row, or as a bottom sheet (phone cards). */
export type RowActionsPresentation = "menu" | "sheet";

const RowActionsPresentationKey: InjectionKey<Readonly<Ref<RowActionsPresentation>>> = Symbol("RowActionsPresentation");

/** A VTable tells the row actions inside it how to open; in the phone card layout they open as a bottom sheet. */
export function provideRowActionsPresentation(presentation: Readonly<Ref<RowActionsPresentation>>) {
  provide(RowActionsPresentationKey, presentation);
}

/** The presentation for row actions here; a menu outside a VTable. */
export function useRowActionsPresentation(): Readonly<Ref<RowActionsPresentation>> {
  return inject(RowActionsPresentationKey, computed(() => "menu" as const));
}
